// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-group.k5-form-group>label{font-size:1.7rem!important;font-weight:600}.form-group.k5-form-group input,.form-group.k5-form-group label,.form-group.k5-form-group select{font-size:1.7rem}.form-group.k5-form-group span{margin-top:5px}", ""]);
// Exports
module.exports = exports;
